import Icon from '@mui/icons-material/LibraryBooks'

export default {
  name: 'events',
  icon: Icon,
  options: {
    defaultSort: { field: 'date', order: 'DESC' },
  },
}
